<template>
	<v-container fluid>
		<div class="base-page">
			<logo-with-title :title="$t('login')" />
			<v-row justify="center">
				<v-img :src="project.image" max-width="75"></v-img>
			</v-row>
			<v-row class="mt-5" justify="center" no-gutters>
				<div class="textColor--text text-h3 text-center px-3">{{ $t('payment.purchase_message', { project: project.subject }) }}</div>
			</v-row>
			<google-button @terms-not-accepted="handleTermsNotAccepted"  />
			
			<v-row justify="center" no-gutters align="center" class="connection-btn mt-5 base-rounded "
						 @click="redirectToRegister">
				<div class="connection-btn--text font-weight-medium">
					{{ $t('welcomePage.RegistrationWithUsernameAndPassword') }}
				</div>
			</v-row>
			<terms-agreement-checkbox 
				ref="termsCheckbox"
				@terms-changed="onTermsChanged"
			/>
			<lang-select/>
		</div>
	</v-container>
</template>

<script>
import CloseAppLogo from "@/components/CloseAppLogo";
import ProjectModule from "@/store/modules/Project.module";
import GoogleButton from "@/components/GoogleButton";
import LogoWithTitle from "@/components/LogoWithTitle";
import LangSelect from "@/components/LangSelect";
import TermsAgreementCheckbox from "@/components/TermsAgreementCheckbox";

export default {
	name: "WelcomeView",
	components: { LangSelect, LogoWithTitle, GoogleButton, CloseAppLogo, TermsAgreementCheckbox },
	props: [],
	data() {
		return {};
	},
	computed: {
		user() {
			return this.$store.state.AuthModule.user;
		},
		project() {
			return this.$store.state.ProjectModule.project;
		},
		title(){
			return `${this.project}`;
		}
	},
	async created() {
		const id = this.$route.query.p;
		if (id) {
			await this.$store.dispatch(
				ProjectModule.types.GET,
				id,
			);
		}
	},

	methods: {
		onTermsChanged(termsAccepted) {
			// Handle terms change if needed
		},
		handleTermsNotAccepted() {
			if (this.$refs.termsCheckbox) {
				this.$refs.termsCheckbox.handleTermsNotAccepted();
			}
		},
		savePlanInLocalStorage(plan) {
			window.localStorage.selectedPlan = plan;
		},
		redirectToGoogle() {
			// save current project here
			sessionStorage.setItem("activeProject", this.$route.query.p);
			window.location = `/login/google?p=${this.$route.query.p}`;
		},
		redirectToRegister() {
			this.$router.push({ path: `/signup?p=${this.$route.query.p}` });
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
